import React from 'react';

export default function PendingPricingSection({ parts }) {
    if (!parts?.length) return null;

    const itemLabel = parts.length === 1 ? 'this item' : 'these items';

    return (
        <section>
            <h2 className='text-3xl font-bold tracking-tight leading-tight text-gray-900'>Pricing in Progress</h2>
            <p className='mt-2 max-w-3xl text-sm text-gray-600'>
                Pricing is not currently available for {itemLabel}. As pricing becomes available an email will be sent with
                current pricing.
            </p>

            <div className='mt-4'>
                <table className='w-full'>
                    <thead>
                        <tr className='text-white'>
                            <th scope='col' className='sticky top-0 z-10 px-4 py-2 font-normal text-left bg-blue-primary'>
                                Part Number
                            </th>
                            <th scope='col' className='sticky top-0 z-10 px-4 py-2 font-normal text-left bg-blue-primary'>
                                Description
                            </th>
                            <th scope='col' className='sticky top-0 z-10 px-4 py-2 font-normal text-center bg-blue-primary'>
                                Condition
                            </th>
                            <th scope='col' className='sticky top-0 z-10 px-4 py-2 font-normal text-left bg-blue-primary'>
                                Trace
                            </th>
                            <th scope='col' className='sticky top-0 z-10 px-4 py-2 font-normal text-center bg-blue-primary'>
                                Tag
                            </th>
                            <th scope='col' className='sticky top-0 z-10 px-4 py-2 font-normal text-center bg-blue-primary'>
                                Lead Time
                            </th>
                            <th scope='col' className='sticky top-0 z-10 px-4 py-2 font-normal text-center bg-blue-primary'>
                                Available Qty
                            </th>
                            <th scope='col' className='sticky top-0 z-10 px-4 py-2 font-normal text-center bg-blue-primary'>
                                Qty Requested
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {parts.map((item) => (
                            <tr key={item.quoteLineId} className='h-16 border-b border-gray-200 hover:bg-gray-50'>
                                <td className='px-4 py-2 font-semibold text-center border'>
                                    {item.partNo}
                                    {item.originalPartNumber && (
                                        <p className='text-xs font-normal text-gray-500'>
                                            original part: ({item.originalPartNumber})
                                        </p>
                                    )}
                                </td>
                                <td
                                    className={`px-4 py-2 text-center border ${item.consignment ? 'text-blue-primary' : ''}`}
                                >
                                    {item.description}
                                    {item.consignment ? ' ***Customer Consignment Inventory***' : ''}
                                </td>
                                <td className='px-4 py-2 text-center border'>{item.condition}</td>
                                <td className='px-4 py-2 border'>{item.trace}</td>
                                <td className='px-4 py-2 text-center border'>{item.tag}</td>
                                <td className='px-4 py-2 text-center border'>{item.leadTime}</td>
                                <td className='px-4 py-2 text-center border'>{item.availableQty}</td>
                                <td className='px-4 py-2 text-center border'>{item.quantityRequested || 1}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
